module.exports = __webpack_public_path__ + "static/media/inverterExplore.dafb1848.png";